import React, { useEffect, useState } from 'react';

import ClearIcon from '@mui/icons-material/Clear';
import EditIcon from '@mui/icons-material/Edit';
import {
    Container,
    Grid,
    IconButton,
    Tooltip,
} from '@sunwisesoftware/sunwise-ui';
import get from 'lodash/get';
import isArray from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { reset } from 'redux-form';
import { createStructuredSelector } from 'reselect';

import { CardContainer, ShowErrors } from 'common/components';
import {
    PlaceholderOwnerInfoCard,
    PlaceholderGeneralInfoCard,
} from 'common/components/placeholders';

import * as actions from './actions';
import {
    CardTotalProposalIssued,
    GeneralInfoCard,
    OwnerInfoCard,
} from './components';
import { NAME } from './constants';
import * as selectors from './selectors';

const CompanyGeneralContainer = ({
    companyDetail,
    companyDetailErrors,
    fetchAgents,
    isFetchingCompanyDetail,
    match,
    resetForm,
}) => {
    const { t } = useTranslation();
    const [ownerEditionEnabled, setOwnerEditionEnabled] = useState(false);

    useEffect(() => {
        if (match.params.id) {
            fetchAgents(match.params.id);
        }
    }, [match.params.id]);

    const handleOnOwnerEditionEnabled = () => {
        setOwnerEditionEnabled(!ownerEditionEnabled);
        resetForm();
    };

    return (
        <Container maxWidth={false}>
            <Grid container sx={{ mb: 3 }}>
                {isArray(companyDetailErrors) &&
                    !isEmpty(companyDetailErrors) && (
                        <Grid size={18}>
                            <ShowErrors
                                errors={companyDetailErrors}
                                severity="error"
                                variant="filled"
                            />
                        </Grid>
                    )}

                <Grid size={18}>
                    <Grid container>
                        <Grid size={{ md: 9, xs: 18 }}>
                            <CardContainer
                                collapsePaddingButton="0px"
                                sxCard={{ height: '470px' }}
                                title={t('Company')}
                                withDivider
                            >
                                <PlaceholderGeneralInfoCard
                                    ready={isFetchingCompanyDetail}
                                >
                                    <GeneralInfoCard
                                        companyDetail={companyDetail}
                                    />
                                </PlaceholderGeneralInfoCard>
                            </CardContainer>
                        </Grid>

                        <Grid size={{ md: 9, xs: 18 }}>
                            <CardContainer
                                collapsePaddingButton="0px"
                                action={
                                    <Tooltip
                                        title={
                                            ownerEditionEnabled
                                                ? t('Cancel')
                                                : t('Edit')
                                        }
                                    >
                                        <span>
                                            <IconButton
                                                aria-label="Owner card action"
                                                disabled={
                                                    isFetchingCompanyDetail
                                                }
                                                onClick={
                                                    handleOnOwnerEditionEnabled
                                                }
                                            >
                                                {ownerEditionEnabled ? (
                                                    <ClearIcon />
                                                ) : (
                                                    <EditIcon />
                                                )}
                                            </IconButton>
                                        </span>
                                    </Tooltip>
                                }
                                title={t('Owner')}
                                withDivider
                            >
                                <PlaceholderOwnerInfoCard
                                    ready={isFetchingCompanyDetail}
                                >
                                    <OwnerInfoCard
                                        editMode={ownerEditionEnabled}
                                        handleOnOwnerEditionEnabled={
                                            handleOnOwnerEditionEnabled
                                        }
                                    />
                                </PlaceholderOwnerInfoCard>
                            </CardContainer>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <CardTotalProposalIssued
                companyId={match.params.id}
                currency={get(companyDetail, 'currency', {})}
                currencyIso={'MXN'}
                currencyLocale={'es-Mx'}
                currencySymbol={'$'}
            />
        </Container>
    );
};

CompanyGeneralContainer.propTypes = {
    companyDetail: PropTypes.object,
    companyDetailErrors: PropTypes.array,
    fetchAgents: PropTypes.func,
    isFetchingCompanyDetail: PropTypes.bool,
    match: PropTypes.object,
    resetForm: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
    companyDetail: selectors.getCompanyDetailData,
    companyDetailErrors: selectors.getCompanyDetailErrors,
    isFetchingCompanyDetail: selectors.getIsFetchingCompanyDetail,
});

const mapDispatchToProps = (dispatch) => ({
    fetchAgents: (companyId) => dispatch(actions.fetchAgents(companyId)),
    resetForm: () => dispatch(reset(`${NAME}/form`)),
    resetComponentState: () => dispatch(actions.reset()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(CompanyGeneralContainer));
